export default __webpack_public_path__ + "static/media/audit-logs-dashboard.5a055300.png";